import { render, staticRenderFns } from "./stockopnamefrm.vue?vue&type=template&id=0ff557e5"
import script from "./stockopnamefrm.vue?vue&type=script&lang=js"
export * from "./stockopnamefrm.vue?vue&type=script&lang=js"
import style0 from "./stockopnamefrm.vue?vue&type=style&index=0&id=0ff557e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports